module.exports = __webpack_public_path__ + "static/media/expoChicagologo.82ac98f0.svg";